module.exports = __webpack_public_path__ + "img/ai-in-trading-and-retail.818a190b.png";